import angular from 'angular';
import RelatedPostsComponent from './related-posts.component';

let RelatedPostsModule = angular.module('catalog.relatedPosts', [])
  .component('relatedPosts', RelatedPostsComponent);

export default RelatedPostsModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/related-posts/related-posts.js
 **/